import request from "./../utils/request";

export const ACTIVITY_API = {
    ACTIVITY: {
        list(cursor, filters) {
            return request({
                url: `/activity/list`,
                method: "post",
                data: {
                    cursor,
                    filters,
                },
            });
        },
        logDownload(activityType, payload) {
            return request({
                url: `/activity/log-download`,
                method: "post",
                data: {
                    activityType,
                    payload,
                },
            });
        },
    },
    NOTIFICATION: {
        getMySettings() {
            return request({
                url: `/users/me/notification-settings`,
                method: "get",
            });
        },
        getUnreadNotifications(cursor, filters) {
            return request({
                url: `/notifications/list/unread-notifications`,
                method: "post",
                data: { cursor, filters },
            });
        },
        getAllNotifications(cursor, filters) {
            return request({
                url: `/notifications/list/all-notifications`,
                method: "post",
                data: { cursor, filters },
            });
        },
        markAsSeen(notificationIds) {
            return request({
                url: `/notifications/mark-as-seen`,
                method: "post",
                data: { notificationIds },
            });
        },
        markAsUnSeen(notificationIds) {
            return request({
                url: `/notifications/mark-as-unseen`,
                method: "post",
                data: { notificationIds },
            });
        },
        markAsSeenAll() {
            return request({
                url: `/notifications/mark-as-seen-all`,
                method: "post",
            });
        },
        updateSingleSetting(platform, field, value) {
            return request({
                url: `/notifications/settings`,
                method: "patch",
                data: {
                    scope: field,
                    platform,
                    value,
                },
            });
        },
        getNotificationCount() {
            return request({
                url: `/notifications/count`,
                method: "get",
            }).then((res) => res.data);
        },
    },
};
